type VarStringFormTypes = [string, string] | string | number;

/**
 * Tagged template literal to help with pluralizing text. Works like a string template literal, but wherever
 * a tuple is passd in as ${[string, string]}, the first will be the singular form used, and the second will
 * be the plural form used.
 *
 * @param count {number} - the count value of concern
 * @param placeholder {string} - the string to replace with the count value
 * @returns {string}
 */
export const pluralize = (count: number, placeholder = '$count') => (
  stringParts: TemplateStringsArray,
  ...variableStringForms: VarStringFormTypes[]
) => {
  const isPlural = count !== 1;
  const getStringForm = (value: VarStringFormTypes) => {
    if (Array.isArray(value)) {
      const [singlularForm, pluralForm] = value;
      return isPlural ? pluralForm : singlularForm;
    }
    return value ? String(value) : '';
  };

  return stringParts
    .map((part, index) => {
      const resolvedForm = getStringForm(variableStringForms[index]);
      return part + resolvedForm;
    })
    .join('')
    .replace(placeholder, String(count));
};
